import * as React from 'react'
import {FC, Suspense} from 'react'
import UrlParamsInterface from '../../../../common/types/url-params'
import QuestionAboutEuroins from '../../../../common/components/question-about-euroins'
import GlobalOptionsInterface, {CalcMode} from '../../types/global-options'
import './index.less'
import {HOSTNAME_POLICY_DOWNLOAD} from '../../constants'
import loadable from '@loadable/component'

interface PaymentSuccessContentPropsInterface {
    params: UrlParamsInterface // 11633
    globalOptions: GlobalOptionsInterface
}

const DownloadPolicy = loadable(
    () => import(/* webpackChunkName: "DownloadPolicy" */ '../download-policy/index'),
    {fallback: <div>Загрузка компонента для скачивания полиса...</div>}
)

// const DownloadPolicy = React.lazy(() =>
//     import(/* webpackChunkName: "DownloadPolicy" */ '../download-policy/index')
// )

const PaymentSuccessContent: FC<PaymentSuccessContentPropsInterface> = ({
    params,
    globalOptions,
}) => {
    const {calcMode, code} = globalOptions,
        showDownloadPolicy =
            calcMode === CalcMode.Agent &&
            params.policy_id &&
            code &&
            window.location.hostname === HOSTNAME_POLICY_DOWNLOAD

    return (
        <div className={'psc'}>
            {showDownloadPolicy && (
                <DownloadPolicy agentCode={code} policyId={Number(params.policy_id)} />
                // <Suspense fallback={'Загрузка компонента для скачивания полиса'}>
                //     <DownloadPolicy agentCode={code} policyId={Number(params.policy_id)} />
                // </Suspense>
            )}
            <QuestionAboutEuroins params={params} />
        </div>
    )
}

export default PaymentSuccessContent
